export enum DataSourceKind {
    STABLE,
    PARAMETRIZED
}
